/* Page A: page-specific behaviour. Hero loader, captions, opening-date planner, register filter. */
(function () {
  'use strict';
  var seq = document.querySelector('[data-hero-seq]');
  var stage = document.querySelector('[data-hero-stage]');
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;

  /* ---------- hero: poster first, 3D after load ---------- */
  function webgl() {
    try { var c = document.createElement('canvas'); return !!(c.getContext('webgl2') || c.getContext('webgl')); } catch (e) { return false; }
  }
  if (seq && stage) {
    if (reduce || saveData || !webgl()) seq.classList.add('is-static');
    if (!webgl()) stage.classList.add('no-webgl');
    var load = function () {
      if (!webgl()) return;
      // three.js (classic UMD build) first, then the scene; both after first paint so the poster carries the hero
      var add = function (src, cb) { var s = document.createElement('script'); s.src = src; s.onload = cb; document.body.appendChild(s); };
      var three = seq.getAttribute('data-three-src') || 'https://cdn.jsdelivr.net/npm/three@0.149.0/build/three.min.js';
      add(three, function () { add(seq.getAttribute('data-hero-src') || 'hero3d.js'); });
    };
    if (document.readyState === 'complete') setTimeout(load, 60);
    else addEventListener('load', function () { if (window.requestIdleCallback) requestIdleCallback(load, { timeout: 900 }); else setTimeout(load, 120); });

    /* round 13: dock the form under the finished frame. The hero keeps the frame pinned for a short hold (--tail) while the
       form section slides up to the line just below Liam's quote and the button, then everything scrolls on together. */
    var qstart = document.querySelector('.hero-seq + .qstart');
    var tailEl = seq.querySelector('.hero-seq__tail');
    var dockNow = function () {
      if (!qstart || !tailEl) return;
      if (seq.classList.contains('is-static')) { qstart.style.marginTop = ''; seq.style.removeProperty('--tail'); return; }
      var H = stage.offsetHeight, top = stage.getBoundingClientRect().top, bottom = 0;
      var parts = [stage.querySelector('.stage__built')];
      if (innerWidth > 899) parts.push(stage.querySelector('.stage__cta'));
      parts.forEach(function (el) { if (el) bottom = Math.max(bottom, el.getBoundingClientRect().bottom - top); });
      var line = Math.min(H, Math.max(H * 0.45, bottom + 24));
      var range = seq.offsetHeight - tailEl.offsetHeight - H;
      var overlap = Math.round(H - line), tail = Math.max(0, Math.round(overlap - 0.16 * range));
      if (Math.abs((parseFloat(qstart.style.marginTop) || 0) + overlap) > 2) qstart.style.marginTop = -overlap + 'px';
      if (Math.abs(tailEl.offsetHeight - tail) > 2) seq.style.setProperty('--tail', tail + 'px');
    };
    var dockSoon = function () { requestAnimationFrame(dockNow); };
    dockSoon();
    addEventListener('resize', dockSoon);
    addEventListener('load', dockSoon);
    document.addEventListener('verve:aud', dockSoon); // headline length changes with the audience
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(dockSoon);

    var rev = stage.querySelector('[data-rev]');
    document.addEventListener('verve:hero-step', function (e) {
      var step = e.detail;
      stage.classList.toggle('is-photo', step === 4);
      if (rev) rev.textContent = step >= 2 ? 'B' : 'A';
      if (window.verveTrack) window.verveTrack('hero_step', { step: step });
    });
  }

  /* ---------- opening-date planner ---------- */
  var months = document.querySelector('[data-months]');
  var tl = document.querySelector('[data-tl]');
  if (months && tl) {
    var now = new Date();
    var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var fmt = function (d) { return d.getDate() + ' ' + MON[d.getMonth()]; };
    var html = '';
    for (var i = 1; i <= 12; i++) {
      var d = new Date(now.getFullYear(), now.getMonth() + i, 15);
      html += '<label class="month"><input type="radio" name="open-month" value="' + d.toISOString() + '"' + (i === 4 ? ' checked' : '') + '><span>' + MON[d.getMonth()] + '<small>' + d.getFullYear() + '</small></span></label>';
    }
    months.insertAdjacentHTML('beforeend', html);
    var weeksEl = tl.querySelector('[data-tl-weeks]');
    var win = tl.querySelector('[data-tl-window]');
    var pts = tl.querySelector('[data-tl-pts]');
    var list = tl.querySelector('[data-tl-list]');
    var note = tl.querySelector('[data-tl-note]');
    var DAY = 864e5;
    function render(openISO) {
      var open = new Date(openISO);
      var start = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      var total = Math.max(7, Math.round((open - start) / DAY));
      var weeks = Math.round(total / 7);
      var design = new Date(start.getTime() + 7 * DAY);
      var install = new Date(open.getTime() - 14 * DAY);
      var winA = new Date(start.getTime() + 14 * DAY);
      var winB = new Date(open.getTime() - 21 * DAY);
      if (winB < winA) winB = winA;
      var pct = function (d) { return Math.min(100, Math.max(0, (d - start) / (open - start) * 100)); };
      weeksEl.textContent = weeks + ' WEEKS TO OPENING DAY';
      win.style.left = pct(winA) + '%';
      win.style.width = Math.max(1.5, pct(winB) - pct(winA)) + '%';
      var items = [
        { cls: 'tl__pt--start', at: 0, date: 'THIS WEEK', b: 'Send your floor plan', t: 'A photo of a sketch is fine.' },
        { at: pct(design), date: 'BY ' + fmt(design).toUpperCase(), b: '3D design and itemised quote', t: 'Free. Change it as often as you like.' },
        { at: (pct(winA) + pct(winB)) / 2, date: fmt(winA).toUpperCase() + ' TO ' + fmt(winB).toUpperCase(), b: 'Lock the quote and order', t: 'Exact timing depends on stock. Confirmed in writing.', window: true },
        { at: pct(install), date: 'FROM ' + fmt(install).toUpperCase(), b: 'Delivery and install', t: 'Scheduled backwards from your date.' },
        { cls: 'tl__pt--end', at: 100, date: fmt(open).toUpperCase(), b: 'Doors open', t: 'Your name on the door.' }
      ];
      // desktop: evenly spaced labels, numbered dots on a to-scale track
      pts.innerHTML = items.map(function (it, k) {
        var left = k === 0 ? 0 : k === items.length - 1 ? 100 : 12 + k * 19;
        return '<div class="tl__pt ' + (it.cls || '') + '" style="left:' + left + '%"><time><span class="tl__n">' + (k + 1) + '</span>' + it.date + '</time><b>' + it.b + '</b>' + it.t + '</div>';
      }).join('');
      // dots on the track at true positions
      tl.querySelectorAll('.tl__dot').forEach(function (n) { n.remove(); });
      var track = tl.querySelector('.tl__track');
      items.forEach(function (it, k) {
        var dot = document.createElement('span');
        dot.className = 'tl__dot' + (k === items.length - 1 ? ' is-end' : '');
        dot.style.left = it.at + '%';
        dot.textContent = k + 1;
        track.appendChild(dot);
      });
      pts.querySelectorAll('.tl__pt').forEach(function (n, k) { n.setAttribute('data-n', k + 1); });
      // mobile list
      list.innerHTML = items.map(function (it, k) {
        return '<li class="' + (k === items.length - 1 ? 'is-end' : '') + (it.window ? ' is-window' : '') + '"><time>' + it.date + '</time><b>' + it.b + '</b><br>' + it.t + '</li>';
      }).join('');
      if (weeks < 8) note.innerHTML = '<b>That’s tight.</b><span>It can be done, and stocked lines dispatch the same day from the Gold Coast. Call us today on 1300 1947 48 so we can check stock against your date.</span>';
      else if (weeks <= 16) note.innerHTML = '<b>That’s a normal runway.</b><span>Most new fit-outs we see take 8 to 16 weeks from signed lease to open doors. Send the plan this week and you have room to get the layout right.</span>';
      else note.innerHTML = '<b>You have time.</b><span>Use it to get the layout right and order without rushing. The 3D design is free, so there is no cost to starting early.</span>';
    }
    months.addEventListener('change', function (e) { if (e.target.name === 'open-month') { render(e.target.value); if (window.verveTrack) window.verveTrack('planner_month', { month: e.target.value.slice(0, 7) }); } });
    render(months.querySelector('input:checked').value);
  }

  /* ---------- register filter ---------- */
  var filt = document.querySelector('[data-reg-filter]');
  if (filt) {
    filt.addEventListener('change', function (e) {
      var v = e.target.value;
      document.querySelectorAll('.reg__row[data-cat]').forEach(function (r) { r.hidden = !(v === 'all' || r.getAttribute('data-cat') === v); });
    });
  }
})();

/* logo strip: mark it scrollable (for the edge fade) only when the logos don't all fit, and drop the fade at the end */
(function () {
  var row = document.querySelector('[data-logo-row]');
  if (!row) return;
  var check = function () {
    var scroll = row.scrollWidth > row.clientWidth + 2;
    row.classList.toggle('is-scroll', scroll);
    row.classList.toggle('at-end', scroll && row.scrollLeft + row.clientWidth >= row.scrollWidth - 4);
  };
  row.addEventListener('scroll', check, { passive: true });
  addEventListener('resize', check);
  addEventListener('load', check);
  check();
})();

/* drawn vs built tabs + play the designer clip only while on screen */
(function () {
  var sec = document.querySelector('.dvb');
  if (sec) sec.addEventListener('change', function (e) {
    if (e.target.name !== 'dvb') return;
    sec.querySelectorAll('[data-dvb]').forEach(function (el) { el.hidden = el.getAttribute('data-dvb') !== e.target.value; });
  });
  var vids = document.querySelectorAll('video[data-autoplay-inview]');
  if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (en) { var v = en.target; if (en.isIntersecting) { v.play().catch(function () {}); } else { v.pause(); } });
  }, { threshold: 0.4 });
  vids.forEach(function (v) { io.observe(v); });
})();

/* questions: one answer at a time (desktop tabs, phone accordion) */
(function () {
  var mobile = matchMedia('(max-width:900px)');
  function open(group, btn, toggle) {
    group.querySelectorAll('.qx__q').forEach(function (b) {
      var on = b === btn && !(toggle && b.getAttribute('aria-expanded') === 'true');
      b.setAttribute('aria-expanded', on ? 'true' : 'false');
      document.getElementById(b.getAttribute('aria-controls')).hidden = !on;
    });
  }
  document.querySelectorAll('.qx').forEach(function (g) {
    var first = g.querySelector('.qx__q');
    if (first) open(g, first, false);
    g.addEventListener('click', function (e) {
      var b = e.target.closest('.qx__q'); if (!b) return;
      open(g, b, mobile.matches);
      if (window.verveTrack) window.verveTrack('question_open', { q: b.querySelector('.qx__t').textContent });
    });
  });
})();
